import { Body1 } from "@fluentui/react-components";

interface TeamEmptyStateProps {
  message: string;
}

export const TeamEmptyState = ({ message }: TeamEmptyStateProps) => (
  <section className="m-4 text-center">
    <Body1>{message}</Body1>
  </section>
);
